const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const API_ENDPOINTS = {
  // AUTH
  signup: `${API_BASE_URL}/api/auth/signup`,
  signin: `${API_BASE_URL}/api/auth/signin`,
  verifyOtp: `${API_BASE_URL}/api/auth/verify-otp`,
  resendOtp: `${API_BASE_URL}/api/auth/resend-otp`,

  // PASSWORD
  resetPasswordOtp: `${API_BASE_URL}/api/auth/reset-password-otp`,
  verifyResetOtp: `${API_BASE_URL}/api/auth/verify-password-reset-otp`,
  resetPassword: `${API_BASE_URL}/api/auth/reset-password`,

  // USER
  me: `${API_BASE_URL}/api/auth/me`,
checkUserStatus: `${API_BASE_URL}/api/auth/check-status`,
  // SUBSCRIPTIONS 
  verifySubscription: `${API_BASE_URL}/api/subscriptions/verify-session`,
  createSubscriptionAuto: `${API_BASE_URL}/api/subscriptions/create-checkout`,
  mySubscriptions: `${API_BASE_URL}/api/subscriptions/my-subscriptions`,
  cancelSubscription: (subscriptionId) => `${API_BASE_URL}/api/subscriptions/cancel/${subscriptionId}`,
  invoice: (subscriptionId) => `${API_BASE_URL}/api/subscriptions/invoice/${subscriptionId}`,

  // CONTACT
  contact: `${API_BASE_URL}/api/public-contacts`,
};

//  HELPER FUNCTIONS - Copy everywhere use karo
export const getAuthHeaders = () => {
  const token = localStorage.getItem('token') || localStorage.getItem('holaToken');
  return {
    'Content-Type': 'application/json',
    ...(token && { 'Authorization': `Bearer ${token}` })
  };
};

//  Universal token getter (Web/Android/iOS)
export const getUniversalToken = () => {
  // Android WebView
  if (typeof window.Android !== 'undefined' && window.Android.getToken) {
    return window.Android.getToken();
  }
  // iOS WebView
  else if (typeof window.webkit !== 'undefined' && window.webkit.messageHandlers?.tokenHandler) {
    return window.webkit.messageHandlers.tokenHandler.postMessage('getToken');
  }
  // Web browser
  else {
    return localStorage.getItem('token') || localStorage.getItem('holaToken');
  }
};

//  API call helper with error handling
export const apiCall = async (endpoint, options = {}) => {
  const token = getUniversalToken();
  
  try {
    const response = await fetch(endpoint, {
      ...options,
      headers: {
        ...options.headers,
        ...getAuthHeaders(),
        ...(token && !options.headers?.Authorization && { 'Authorization': `Bearer ${token}` })
      }
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.error || data.message || 'API error');
    }
    
    return data;
  } catch (error) {
    console.error('API Error:', error);
    throw error;
  }
};

export default API_BASE_URL;
